import { fuenteI } from "./fuentes.interface";

export class histActFuenteI{
  id:number;
  fuente:fuenteI;
  fecha:string;
  accion:String;
  novedad:String;
  observacion:String;
  usuarioMod:String;
}
